import {
  datesEqual,
  firstDayOfMonthUTC,
  firstDayOfWeekUTC,
  getUTCAfternoon,
} from '@epicuro-next/utilities';
import { DateTime } from 'luxon';

import { DeliveryWindowType } from '../../../../../../../graphql-api/gql-api-interfaces';
import { BulkTypeDeliveryPeriod } from '../models';

export const checkIsNow = (
  windowType: DeliveryWindowType,
  period: string | BulkTypeDeliveryPeriod | null,
) => {
  // safety check if period is accidentally is a bulk period
  if (typeof period !== 'string') {
    return false;
  }

  const nowISO = DateTime.now().toISO();
  const now = DateTime.fromISO(getUTCAfternoon(nowISO)).toJSDate();
  const startOfWeek = DateTime.fromISO(firstDayOfWeekUTC(nowISO)).toJSDate();
  const startOfMonth = DateTime.fromISO(firstDayOfMonthUTC(nowISO)).toJSDate();
  const periodDate = DateTime.fromISO(period).toJSDate();

  const checkStrategies = {
    [DeliveryWindowType.Day]: () => datesEqual(now, periodDate),
    [DeliveryWindowType.Week]: () => datesEqual(startOfWeek, periodDate),
    [DeliveryWindowType.Month]: () => datesEqual(startOfMonth, periodDate),
  };

  return checkStrategies[windowType]();
};
